import { P4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const HighlightWrapper = styled(P4)<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 6px 12px;
  color: ${themeStyle.backgroundAlt};
  background: ${({ isActive }) =>
    isActive ? themeStyle.varSelectionBlue : themeStyle.varInkMedium};
  border-radius: ${themeStyle.radiusSmall};
`;

export const Subtitle = styled(P4)`
  text-align: left;
`;
